// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3UObv","signatureBlock":"Footer_signatureBlock__2GtjA","signature":"Footer_signature__1jyHl"};